import { addValidationRule } from 'formsy-react'

const cleanInput = value => value.replace(/[^\d]+/g, '')
const cleanCNPJ = cnpj =>
    String(cnpj)
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '')

const calculateCPFCheckDigit = numbers => {
    const length = numbers.length
    let sum = 0

    for (let i = 0; i < length; i++) {
        sum += parseInt(numbers[i]) * (length + 1 - i)
    }

    const result = (sum * 10) % 11
    return [10, 11].includes(result) ? 0 : result
}

export const isValidCNPJ = (values, cnpj) => {
    if (!cnpj) return false
    cnpj = cleanCNPJ(cnpj)

    return /^([A-Z0-9]{14})$/.test(cnpj)
}

export const isValidCNPJLength = (values, cnpj) => {
    if (!cnpj) return false
    cnpj = cleanCNPJ(cnpj)

    return cnpj.length === 14
}

export const isValidCPF = (values, cpf) => {
    if (!cpf) return false

    cpf = cleanInput(cpf)

    if (/^(\d)\1{10}$/.test(cpf)) return false

    const base = cpf.substring(0, 9)
    const digit1 = calculateCPFCheckDigit(base)
    const digit2 = calculateCPFCheckDigit(base + digit1)

    return cpf === base + digit1 + digit2
}

export const isValidCPFLength = (values, cpf) => {
    if (!cpf) return false
    cpf = cleanInput(cpf)
    return cpf.length === 11
}

export const isValidNIT = (values, nit) => {
    if (!nit) return false

    nit = cleanInput(nit)

    return /^\d{9}$/.test(nit)
}

export const isValidCoIndividual = (values, indv) => {
    if (!indv) return false
    indv = cleanInput(indv)
    return indv.length >= 6 && indv.length <= 10
}

export const isValidNITLength = (values, nit) => {
    if (!nit) return false
    nit = cleanInput(nit)
    return nit.length === 9
}

export const loadValidations = () => {
    addValidationRule('isValidCNPJ', isValidCNPJ)
    addValidationRule('isValidCPF', isValidCPF)
    addValidationRule('isValidCNPJLength', isValidCNPJLength)
    addValidationRule('isValidCPFLength', isValidCPFLength)
    addValidationRule('isValidCoIndividual', isValidCoIndividual)
    addValidationRule('isValidNITLength', isValidNITLength)
    addValidationRule('isValidNIT', isValidNIT)
}
